import type { Nutrition, Recipe } from '@/service/recipe/types';

// Recipes saved before multiple pictures only have `image`
export function imagesOf(recipe: Pick<Recipe, 'image' | 'images'>): string[] {
  if (recipe.images?.length) return recipe.images;
  return recipe.image ? [recipe.image] : [];
}

// Only web links become links, so a stored "javascript:" URL is never one
export function safeUrl(url: string | undefined): string | undefined {
  if (!url) return undefined;
  try {
    const parsed = new URL(url);
    return ['http:', 'https:'].includes(parsed.protocol)
      ? parsed.href
      : undefined;
  } catch {
    return undefined;
  }
}

// "bbcgoodfood.com" for https://www.bbcgoodfood.com/recipes/...
export function sourceLabel(url: string): string {
  return new URL(url).hostname.replace(/^www\./, '');
}

// ["450 kcal", "20 g protein", ...] for the values that are set
export function nutritionFacts(nutrition: Nutrition | undefined): string[] {
  const { kcal, protein, carbs, fat } = nutrition ?? {};
  const grams = (value: number | undefined, name: string) =>
    value === undefined ? undefined : `${round(value)} g ${name}`;
  return [
    kcal === undefined ? undefined : `${round(kcal)} kcal`,
    grams(protein, 'protein'),
    grams(carbs, 'carbs'),
    grams(fat, 'fat'),
  ].filter((fact): fact is string => fact !== undefined);
}

function round(value: number): number {
  return Math.round(value * 10) / 10;
}
